import React, { useEffect, useRef, useState } from 'react';
import NotificationAlert from 'react-notification-alert';
import { Edit, Delete, Add, Tune } from '@mui/icons-material';
import './session-management.css';
import { Dialog } from '@mui/material';
import Slide from '@mui/material/Slide';
import firebase from 'firebase';
import MultiSelect from 'react-multiselect-checkboxes';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
} from 'reactstrap';
import AddSession from './AddSession/AddSession';
import { REDIRECT_URI, scope } from 'utils';
import { useLocation, useNavigate } from 'react-router-dom';
import SessionCalendar from './SessionCalendar/SessionCalendar';
import SessionCard from './SessionCard/SessionCard';
import { Webex_Base_Url } from 'utils';
import axios from 'axios';
import { accessToken } from 'utils';
import MeetingScreen from './MeetingScreen/MeetingScreen';

import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import { REDIRECT_URI_DEV } from 'utils';
import { format } from 'date-fns';
import AddServiceAppDetails from './AddServiceAppDetails/AddServiceAppDetails';
import { updateTeacherIntegrationToken } from 'utils';
import { updateAdminIntegrationToken } from 'utils';
import { REDIRECT_URI_PROD } from 'utils';

const SessionManagement = ({ setWebex, setMeeting, webex }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [meetings, setMeetings] = useState([]);
  const [webexObj, setWebexObj] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [isInitializing, setIsInitializing] = useState(false);

  const [meetingJoinClicked, setMeetingJoinClicked] = useState(false);

  const [networkDeactivated, setNetworkDeactivated] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [teacherList, setTeacherList] = useState([]);
  const [isTeacher, setIsTeacher] = useState(false);
  const [teacherId, setTeacherId] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState();
  const [openAddServiceAppInfo, setOpenAddServiceAppInfo] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});

  const [hostKey, setHostKey] = useState('');
  const [apiMeetingId, setApiMeetingId] = useState('');
  const [ongoingclassName, setOngoingClassname] = useState(false);

  const [loadingMeet, setLoadingMeet] = useState(false);

  const notifi = useRef();
  const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
  });

  const [openAddSession, setOpenAddSession] = useState(false);

  const token = accessToken();

  const loginWithWebex = () => {
    localStorage.removeItem('webex_token');
    const authUrl = `https://webexapis.com/v1/authorize?client_id=${process.env?.REACT_APP_INTEGRATION_APP_CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI_PROD}&scope=${scope}`;
    window.location.href = authUrl;
  };

  const exchangeToken = async (code) => {
    try {
      const response = await fetch('https://webexapis.com/v1/access_token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          grant_type: 'authorization_code',
          client_id: process.env?.REACT_APP_INTEGRATION_APP_CLIENT_ID,
          client_secret: process.env?.REACT_APP_INTEGRATION_APP_CLIENT_SECRET,
          code: code,
          redirect_uri: REDIRECT_URI,
        }),
      });

      const data = await response.json();
      if (data.access_token) {
        localStorage.setItem('webex_token', data.access_token);
        let tokenData = {
          accessToken: data?.access_token,
          expiresIn: data?.expires_in,
          lastUpdated: new Date().toISOString(),
          refreshToken: data?.refresh_token,
        };

        if (!networkDeactivated) {
          firebase.auth().onAuthStateChanged((user) => {
            if (user) {
              let uid = user.uid;

              db.collection('zSystemUsers')
                .get()
                .then((querySnapshot) => {
                  let data = querySnapshot.docs.map((doc) => doc.data());
                  let currentUser = data.filter(
                    (filterData) => filterData._uniqueID === uid
                  );

                  if (currentUser[0]?.isTeacher) {
                    updateTeacherIntegrationToken(
                      currentUser[0]?._uniqueID,
                      tokenData
                    );
                  } else {
                    delete tokenData.lastUpdated;
                    updateAdminIntegrationToken(tokenData);
                  }
                });
            }
          });
        }
      }
    } catch (error) {}
  };

  const checkIsToday = (date) => {
    const inputDate = date instanceof Date ? date : new Date(date);
    const today = new Date();

    return (
      inputDate.getDate() === today.getDate() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getFullYear() === today.getFullYear()
    );
  };

  const handleRefreshTeacherToken = async (user) => {
    try {
      const functions = firebase.functions();
      const refreshToken = functions.httpsCallable(
        'updateAdminTeacherItegrationAppDetailsToken'
      );
      await refreshToken();
    } catch (err) {
      console.log(err);
    }
  };

  const getTeacherToken = async (teacherId) => {
    try {
      const querySnapshot = await db
        .collection('zSystemUsers')
        .where('_uniqueID', '==', teacherId)
        .where('isTeacher', '==', true)
        .get();

      const doc = querySnapshot.docs[0];
      const dataObj = doc.data()?.intrigrationTokenData;
      localStorage.setItem('webex_token', dataObj?.accessToken);
      const isToday = checkIsToday(dataObj?.lastUpdated);
      if (!isToday) {
        handleRefreshAdminToken();
      }
      console.log(dataObj, 'response');
    } catch (err) {
      console.log(err, 'error');
    }
  };

  const handleRefreshAdminToken = async (user) => {
    try {
      const functions = firebase.functions();
      const refreshToken = functions.httpsCallable(
        'updateAdminItegrationAppDetailsToken'
      );
      await refreshToken();
    } catch (err) {
      console.log(err);
    }
  };

  const getAdminToken = async () => {
    try {
      const querySnapshot = await db
        .collection('adminItegrationAppDetails')
        .limit(1)
        .get();

      const doc = querySnapshot.docs[0];
      const { accessToken, expiresIn, lastUpdated } = doc.data();
      localStorage.setItem('webex_token', accessToken);

      const isToday = checkIsToday(lastUpdated);
      if (!isToday) {
        handleRefreshAdminToken();
      }
      console.log(doc.data(), 'responseAd');
    } catch (error) {}
  };

  const getMeetings = async () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    setLoadingMeet(true);
    let date = format(selectedDate, 'dd-MM-yyyy');
    try {
      const convertToTimestamp = (
        dateString,
        endOfDay = false,
        onlyDate = false
      ) => {
        // dateString is in "DD-MM-YYYY"
        const [day, month, year] = dateString.split('-').map(Number);

        if (onlyDate) {
          // Return in YYYY-MM-DD format
          const pad = (num) => num.toString().padStart(2, '0');
          return `${year}-${pad(month)}-${pad(day)}`;
        }

        // Construct UTC date
        const date = new Date(Date.UTC(year, month - 1, day));

        if (endOfDay) {
          date.setUTCHours(23, 59);
        } else {
          date.setUTCHours(0, 0);
        }

        // Format to "YYYY-MM-DDTHH:mm"
        const pad = (num) => num.toString().padStart(2, '0');
        const formatted = `${date.getUTCFullYear()}-${pad(
          date.getUTCMonth() + 1
        )}-${pad(date.getUTCDate())}T${pad(date.getUTCHours())}:${pad(
          date.getUTCMinutes()
        )}`;

        console.log(formatted, 'formatted');
        return formatted;
      };

      let payload = {
        startDate: convertToTimestamp(`${date}`, true),
        lastDate: convertToTimestamp(`${date}`, false, true),
      };

      if (selectedTeacher?.value) {
        payload.teacherEmail = selectedTeacher?.value;
      }

      const functions = firebase.functions();
      const getClasses = functions.httpsCallable('getBatchClassesV2');
      const response = await getClasses(payload);
      if (!response.hasError) {
        const sortMeet = response.data.data.sort((a, b) => {
          const getTimeMinutes = (dateStr) => {
            const [hour, minute] = dateStr.split('T')[1].split(':');
            return parseInt(hour) * 60 + parseInt(minute); // total minutes from midnight
          };

          return getTimeMinutes(a.start) - getTimeMinutes(b.start);
        });
        console.log(sortMeet, 'sortMeet');
        setMeetings(sortMeet);
      }
      document.querySelector('#loading-indicator').style.display = 'none';
      setLoadingMeet(false);
      console.log(response, 'meetings');
    } catch (err) {
      document.querySelector('#loading-indicator').style.display = 'none';
      setLoadingMeet(false);
      notify('Something went wrong', true);
    }
  };

  const handleSdk = async () => {
    if (window && token) {
      if (!isInitializing) {
        setIsInitializing(true);
      }
      let webex = window?.Webex?.init({
        credentials: {
          access_token: token,
          client_id: process.env?.REACT_APP_INTEGRATION_APP_CLIENT_ID,
          client_secret: process.env?.REACT_APP_INTEGRATION_APP_CLIENT_SECRET,
          clientType: 'web',
        },
        reconnection: {
          enabled: true,
          autoRejoin: true,
        },
      });
      if (webex) {
        webex.credentials.set({ access_token: accessToken() });
        await syncWebex(webex);
        // await webex.meetings.register();

        setWebex(webex);
        setWebexObj(webex);
      }
    }
  };

  const syncWebex = async (webex) => {
    try {
      await webex.meetings.syncMeetings();
    } catch (error) {}
  };

  const getTeachersOfSelectedBatches = async () => {
    try {
      const teacherRef = db.collection('zSystemUsers');

      const snapshot = await teacherRef
        .where('isTeacher', '==', true)
        .where('status', '==', 0)
        .get();
      if (snapshot.empty) {
        return;
      }

      const teachers = snapshot.docs.map((doc) => {
        console.log(doc.data(), 'docDataTeacher');
        let data = doc.data();
        return {
          id: doc.id,
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
          isTeacher: data?.isTeacher,
        };
      });
      setTeacherList(teachers);
    } catch (error) {}
  };

  const getUsers = () => {
    firebase.auth().onAuthStateChanged((user) => {
      setIsLoading(true);
      if (user) {
        let uid = user.uid;
        console.log(uid);
        db.collection('zSystemUsers')
          .get()
          .then((querySnapshot) => {
            let data = querySnapshot.docs.map((doc) => doc.data());
            let currentUser = data.filter(
              (filterData) => filterData._uniqueID === uid
            );
            if (currentUser[0]?.isTeacher) {
              setSelectedTeacher({
                label: currentUser[0].firstname + ' ' + currentUser[0].lastname,
                value: currentUser[0]?.email,
              });
              setTeacherId(currentUser[0]?._uniqueID);
              setIsTeacher(true);
              if (!networkDeactivated) {
                if (!webex) {
                  setIsInitializing(true);
                }
                getTeacherToken(currentUser[0]?._uniqueID);
              }
            } else {
              if (!networkDeactivated) {
                if (!webex) {
                  setIsInitializing(true);
                }
                getAdminToken();
                getTeachersOfSelectedBatches();
              }
            }
            setIsLoading(false);
          });
      } else {
        // User is signed out.
        // ...
      }
    });
  };

  useEffect(() => {
    if (!webex) {
      handleSdk();
    }
  }, [window, token]);

  useEffect(() => {
    console.log(location, ' fetched location');

    if (location.state?.triggerReload) {
      navigate(location.pathname, { replace: true, state: {} });
      window.location.reload();
    }
    if (selectedDate && !isLoading) {
      if (!networkDeactivated) {
        getMeetings();
      }
    }
  }, [selectedDate, isLoading, selectedTeacher]);

  useEffect(() => {
    if (!networkDeactivated) {
      getUsers();
    }
  }, []);

  console.log(editData, isEditing, '........ 2');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const token = accessToken();
    if (code && !token) {
      exchangeToken(code);
      // getUsers(code)
    }
  }, []);

  useEffect(() => {
    if (webex && isInitializing) {
      setIsInitializing(false);
    }
  }, [isInitializing, webex]);

  return (
    <div className='content'>
      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notifi} />
      </div>

      <Card>
        <CardHeader
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <CardTitle
            tag='h4'
            style={{
              marginRight: 'auto',
              fontWeight: 300,
              textAlign: 'left',
            }}
          >
            {isTeacher ?"Time Table" :'SESSION MANAGEMENT'}
          </CardTitle>

          {!isLoading && !isTeacher && (
            <Button
              color='info'
              style={{ marginRight: 25 }}
              onClick={() => setOpenAddServiceAppInfo(true)}
            >
              Add Service App Details
            </Button>
          )}

          <Button
            color='info'
            style={{ marginRight: 25 }}
            onClick={loginWithWebex}
          >
            Get Token
          </Button>
          {!isLoading && !isTeacher && (
            <Button
              color='info'
              style={{ marginRight: 25 }}
              onClick={() => setOpenAddSession(true)}
            >
              Create Class <Add />
            </Button>
          )}
        </CardHeader>
        <CardBody style={{ paddingTop: '10px' }}>
          {!isLoading && !isTeacher && (
            <FormGroup style={{ width: '200px' }}>
              <MultiSelect
                value={selectedTeacher}
                options={
                  teacherList?.length > 0
                    ? [
                        { label: 'All', value: '' },
                        ...teacherList?.map((teacher) => ({
                          label: teacher?.firstname + ' ' + teacher?.lastname,
                          value: teacher?.email,
                        })),
                      ]
                    : []
                }
                onChange={(option) => {
                  setSelectedTeacher(option);
                }}
                placeholder='Select Teacher'
                isMulti={false}
                menuPortalTarget={
                  typeof window !== 'undefined' ? document.body : null
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '7px',
                    minHeight: '40px',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#FFF',
                    zIndex: 9999,
                  }),
                  // menuPortal: (base) => ({
                  //   ...base,
                  //   zIndex: 9999,
                  // }),
                }}
              />
            </FormGroup>
          )}

          <div>
            <SessionCalendar
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />

            <div className='session-management-meeting-container'>
              {meetings?.length === 0 && !loadingMeet && (
                <p
                  style={{
                    fontSize: '1rem',
                    width: '100%',
                    textAlign: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  No classes found on selected date
                </p>
              )}
              {meetings?.length > 0 &&
                selectedDate &&
                meetings?.map((meeting) => (
                  <div key={meeting?.id}>
                    <SessionCard
                      // handleMeetingScreen={() => setOpenMeetingScreen(true)}
                      // date={`${selectedDate.getFullYear()}-${
                      //   selectedDate.getMonth() + 1
                      // }-${selectedDate.getDate()}`}
                      meeting={meeting?.meetData}
                      webex={webex}
                      setOnGoingMeeting={setMeeting}
                      setHostKey={setHostKey}
                      setApiMeetingId={() => {
                        setApiMeetingId(meeting?.meetData?.id);
                        setOngoingClassname(meeting?.meetData?.title);
                      }}
                      firebaseMeeting={meeting}
                      setIsEditing={setIsEditing}
                      setEditData={setEditData}
                      getMeeting={getMeetings}
                      setOpenAddSession={setOpenAddSession}
                      setMeetingJoinClicked={setMeetingJoinClicked}
                      meetingJoinClicked={meetingJoinClicked}
                      isTeacher={isTeacher}
                      selectedDate={selectedDate}
                      notify={notify}
                    />
                  </div>
                ))}
            </div>
          </div>
        </CardBody>
      </Card>

      {/* {openMeetingScreen && (
        <Dialog
          fullScreen
          open={openMeetingScreen}
          onClose={() => setOpenMeetingScreen(false)}
          TransitionComponent={Transition}
        >
         
          <MeetingScreen
            webex={webexObj}
            meeting={onGoingMeeting}
            hostKey={hostKey}
            closeMeeting={() => setOpenMeetingScreen(false)}
            notify={notify}
            apiMeetingId={apiMeetingId}
            ongoingclassName={ongoingclassName}
            networkDeactivated={networkDeactivated}
            setNetworkDeactivated={setNetworkDeactivated}
          />
          
        </Dialog>
      )} */}
      {openAddServiceAppInfo && (
        <Dialog
          maxWidth={'md'}
          open={openAddServiceAppInfo}
          onClose={() => setOpenAddServiceAppInfo(false)}
          TransitionComponent={Transition}
        >
          <AddServiceAppDetails
            handleClose={() => setOpenAddServiceAppInfo(false)}
            notify={notify}
          />
        </Dialog>
      )}
      {openAddSession && (
        <Dialog
          maxWidth={'xl'}
          open={openAddSession}
          onClose={() => setOpenAddSession(false)}
          TransitionComponent={Transition}
        >
          <AddSession
            getMeetings={() => getMeetings()}
            handleClose={() => setOpenAddSession(false)}
            isEditing={isEditing}
            editData={editData}
          />
        </Dialog>
      )}
      {isInitializing && !loadingMeet && (
        <Dialog
          maxWidth={'sm'}
          open={isInitializing && !loadingMeet}
          onClose={() => setIsInitializing(false)}
          TransitionComponent={Transition}
        >
          {!loadingMeet ? (
            <div
              style={{
                display: 'flex',
                gap: '6px',
                background: 'black',
                top: '28%',
                right: '6px',
                fontSize: '12px',
                width: 'fit-content',
                height: 'fit-content',
                zIndex: 100,
                padding: '30px',
                overflow: 'hidden',
              }}
            >
              <p
                style={{
                  whiteSpace: 'nowrap',
                  marginRight: '6px',
                  color: 'white',
                  fontSize: '1.25rem',
                  marginBottom: '0',
                }}
              >
                Please wait while we setup the things for you...
              </p>{' '}
              {/* <ResizeLoader />{' '} */}
            </div>
          ) : (
            <></>
          )}
        </Dialog>
      )}
    </div>
  );
};

export default SessionManagement;
